import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { savePrefilledLinesIfNeededThunk } from '../redux/thunks/prefilled-lines/SavePrefilledLinesIfNeededThunk';

const AUTO_SAVE_INTERVAL = 5000;

export const usePrefilledLinesAutoSave = (enabled: boolean) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const intervalId = enabled
      ? setInterval(() => {
          dispatch(savePrefilledLinesIfNeededThunk());
        }, AUTO_SAVE_INTERVAL)
      : null;

    return () => {
      if (intervalId != null) {
        clearInterval(intervalId);
      }
    };
  }, [dispatch, enabled]);
};
